import * as React from "react";

import { User } from "../../models/users";

export const UserProfileIntro = ({ profile_user }: { profile_user: User }) => {
  const profile_escaped = profile_user.profile_escaped;
  if (!profile_escaped) {
    return (
      <div className="prose empty mt-1">
        This user apparently likes an air of mystery about them
      </div>
    );
  }

  return (
    <div
      className="prose mt-1 text-slate-600 dark:text-slate-300 break-all"
      dangerouslySetInnerHTML={{ __html: profile_user.profile_escaped }}
    />
  );
};
